export const roadLabelSource = {
  type: 'vector',
  url: 'https://tiles.openfreemap.org/planet',
  attribution: '© OpenMapTiles © OpenStreetMap contributors',
};

export const roadLabelLayers = [
  {
    id: 'major-road-labels',
    type: 'symbol',
    source: 'roadLabels',
    'source-layer': 'transportation_name',
    minzoom: 11,
    filter: ['in', 'class', 'motorway', 'trunk', 'primary', 'secondary'],
    layout: {
      'symbol-placement': 'line',
      'symbol-spacing': 420,
      'text-field': ['coalesce', ['get', 'name'], ['get', 'ref']],
      'text-font': ['Noto Sans Regular'],
      'text-size': ['interpolate', ['linear'], ['zoom'], 11, 10, 15, 13, 18, 15],
      'text-max-angle': 35,
      'text-padding': 6,
      'text-rotation-alignment': 'map',
      'text-pitch-alignment': 'viewport',
    },
    paint: {
      'text-color': '#354052',
      'text-halo-color': 'rgba(255,255,255,.94)',
      'text-halo-width': 2,
    },
  },
  {
    id: 'secondary-street-labels',
    type: 'symbol',
    source: 'roadLabels',
    'source-layer': 'transportation_name',
    minzoom: 18,
    filter: ['==', 'class', 'tertiary'],
    layout: {
      'symbol-placement': 'line',
      'symbol-spacing': 500,
      'text-field': ['coalesce', ['get', 'name'], ['get', 'ref']],
      'text-font': ['Noto Sans Regular'],
      'text-size': ['interpolate', ['linear'], ['zoom'], 14, 10, 17, 12.5, 19, 14],
      'text-padding': 8,
      'text-rotation-alignment': 'map',
      'text-pitch-alignment': 'viewport',
    },
    paint: {
      'text-color': '#566173',
      'text-halo-color': 'rgba(255,255,255,.92)',
      'text-halo-width': 1.75,
    },
  },
];

export const mapStyle = {
  version: 8,
  glyphs: 'https://tiles.openfreemap.org/fonts/{fontstack}/{range}.pbf',
  sources: {
    carto: {
      type: 'raster',
      tiles: [
        'https://a.basemaps.cartocdn.com/rastertiles/voyager_nolabels/{z}/{x}/{y}.png',
        'https://b.basemaps.cartocdn.com/rastertiles/voyager_nolabels/{z}/{x}/{y}.png',
        'https://c.basemaps.cartocdn.com/rastertiles/voyager_nolabels/{z}/{x}/{y}.png',
      ],
      tileSize: 256,
    },
  },
  layers: [
    {
      id: 'carto',
      type: 'raster',
      source: 'carto',
      paint: {
        'raster-opacity': 0.95,
        'raster-saturation': -0.05,
      },
    },
  ],
};
const locationEditorRoadLabelLayers = [
  {
    id: 'location-editor-major-road-labels',
    type: 'symbol',
    source: 'roadLabels',
    'source-layer': 'transportation_name',
    minzoom: 11,
    filter: ['in', 'class', 'motorway', 'trunk', 'primary', 'secondary'],
    layout: {
      'symbol-placement': 'line',
      'symbol-spacing': 280,
      'text-field': ['coalesce', ['get', 'name'], ['get', 'ref']],
      'text-font': ['Noto Sans Regular'],
      'text-size': ['interpolate', ['linear'], ['zoom'], 11, 10, 15, 13, 18, 15],
      'text-max-angle': 35,
      'text-padding': 4,
      'text-rotation-alignment': 'map',
      'text-pitch-alignment': 'viewport',
    },
    paint: { 'text-color': '#354052', 'text-halo-color': 'rgba(255,255,255,.96)', 'text-halo-width': 2 },
  },
  {
    id: 'location-editor-local-road-labels',
    type: 'symbol',
    source: 'roadLabels',
    'source-layer': 'transportation_name',
    minzoom: 14,
    filter: ['in', 'class', 'tertiary', 'minor', 'service'],
    layout: {
      'symbol-placement': 'line',
      'symbol-spacing': 220,
      'text-field': ['coalesce', ['get', 'name'], ['get', 'ref']],
      'text-font': ['Noto Sans Regular'],
      'text-size': ['interpolate', ['linear'], ['zoom'], 14, 10, 17, 12.5, 19, 14],
      'text-max-angle': 40,
      'text-padding': 3,
      'text-rotation-alignment': 'map',
      'text-pitch-alignment': 'viewport',
    },
    paint: { 'text-color': '#4b5565', 'text-halo-color': 'rgba(255,255,255,.96)', 'text-halo-width': 1.8 },
  },
];

export const locationEditorMapStyle = {
  ...mapStyle,
  sources: { ...mapStyle.sources, roadLabels: roadLabelSource },
  layers: [...mapStyle.layers, ...locationEditorRoadLabelLayers],
};
